/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface LoyaltyProductPaidOptions { 
    productId?: string;
    paidDuration?: number;
    paidBoostRateId?: string;
    paidNewsletterTier1Count?: number;
    paidNewsletterTier2Count?: number;
    paidNewsletterTier3Count?: number;
}

